export class Carousel {

  constructor(
    sliderContainer,
    slides,
    visibleItems,
    slidingTimeout
  ) {
    this._sliderContainer = sliderContainer;
    this._slides = [...slides];
    this._visibleItems = visibleItems;
    this._slidingTimeout = slidingTimeout;
  }

  init() {
    if (this._sliderContainer && this._slides.length > 0) {
      this.initSliding();
    }
  }

  initSliding() {
    const slide = () => {
      this._slides.push(this._slides.shift());

      this._slides.forEach(el => {
        const classesToRemove = Array.from(
          new Array(this._visibleItems), (x, index) => `slider__inner__slide--${ index }`
        );

        el.classList.remove(...classesToRemove);
      });

      this._slides.slice(0, this._visibleItems)
        .forEach((el, i) => el.classList.add(`slider__inner__slide--${ i }`));

      setTimeout(requestAnimationFrame.bind(null, slide), this._slidingTimeout);
    };

    requestAnimationFrame(slide);
  }
}
